declare var $: any;
declare var window: any;

export class BiApi {
    public constructor() {}

    public rest(command: string, data: any, config: any) {
        config = {
            ...{
                url: window.keeperPreload.apiEndpoint + '/bi_api/rest/' + command,
                method: 'POST',
                dataType: 'JSON',
                contentType: 'application/json',
                isEU: false,
            },
            ...(config || {}),
        };
        if (config.isEU)
            config.url =
                window.keeperPreload.apiEndpoint.replace('.com', '.eu') + '/rest/' + command;

        data = data || {};
        config.data = JSON.stringify(data);

        let ajax = $.ajax(config);

        return ajax;
    }

    public v1(command: string, data: any, config: any) {
        config = {
            ...{
                url: window.keeperPreload.apiEndpoint + '/bi_api/v1/' + command,
                method: 'POST',
                dataType: 'JSON',
                contentType: 'application/json',
                isEU: false,
            },
            ...(config || {}),
        };
        if (config.isEU)
            config.url = window.keeperPreload.apiEndpoint.replace('.com', '.eu') + '/v1/' + command;

        data = data || {};
        config.data = JSON.stringify(data);

        let ajax = $.ajax(config);

        return ajax;
    }
}
